import { NetworkType } from "@/config";

// Testnet Contract Addresses
export const AccessControlManagerTestnet =
  "0x87D3440372293aCf9149552546F7141AAe05Be91";
export const TokenRegistryTestnet =
  "0x032666197A5d9329e717800FC90E8C951bA12290";
export const ProviderRegistryTestnet =
  "0x038Eb8E227B287d7D42Cf404A07ACb5a7Df7645A";
export const ProviderAttributeRegistryTestnet =
  "0x63942fCb221aDF85ebdFc11a061D5eea2384f00A";
export const FizzRegistryTestnet = "0x6cB3604EeA7Ba303bB1a020fD8e06f034D5534a3";
export const FizzAttributeRegistryTestnet =
  "0xB598170D89046385C62F10670CAe2658f6D8E7D7";
export const EscrowUserTestnet = "0xb8ac4512852409c9b30f10844c3f0a61679fae66";
export const EscrowProtocolTestnet =
  "0xbEDE87cE3411F280B3Ed63027B45f73Cbcd1B441";
export const OrderRequestTestnet = "0xCe9787883b8f3785CCd8C8c3275B5F41068d670A";
export const ComputeLeaseTestnet = "0x70008e46550E628D50310330686A0bc692F722Fd";
export const BidTestnet = "0xe029A4f5e970c389Ca16e48600707496602af5Ed";
export const ResourceRegistryCPUTestnet =
  "0x67B8c2201Eef00d1a8193a2aF301312DD21a286B";
export const ResourceRegistryGPUTestnet =
  "0x2B73F279044347A3B6c9F122Ec6b479b6C2beAc9";
export const ResourceRegistryFactoryTestnet =
  "0xbb132eB1b36D87ef7Ac63c95c05a8a56eCDac3fd";
export const ProviderRewardsManagerTestnet =
  "0xe32279Bf9d47E20AEbb9ec04Ba5FB46536BA2aB5";
export const FizzRewardsManagerTestnet =
  "0xd653644FFD4ec06d173237FbA952C450A4973f5c";
export const RewardTokenTestnet = "0xB28aA1E5074AE0222cf764e2934182775Ee7AB42";
export const FizzNodeRewardTokenTestnet =
  "0xA2400EFe3d7a9E2281F32A66Df18CFFE651c69f3";

// Testnet Token Addresses
export const USDTTestnet = "0x96Ca5955F25648FB44C5D772BAdB4313000C66Fe";
export const USDCTestnet = "0x816413630c39780677E1584D4a6DbAFd76b161F7";
export const DAITestnet = "0xcF5F08686dBE94B88b93FB2E8E5482A7f432C892";
export const WETHTestnet = "0xd74C08f8ffDF88C807367813Ad64a960618f4dcC";
export const CSTTestnet = "0x8E5996A3963011Ca9dFa04E3CB773147F98C0e17";
export const SPONTestnet = "0x76e593392523243ACD38ceD87c2007F14483a86B";
export const USPONTestnet = "0xeD8F325cDc2BA7567395cb451A2ea8FAf40E23D2";

// Mainnet Contract Addresses
export const TokenRegistryMainnet =
  "0xDCD3eeE9f5Fb828C4EaE14B8Fe2382c0dDD6de01";
export const AccessControlMainnet =
  "0x2F6dE416a7AEED365bE49DeB931D263EC742605C";
export const ProviderRegistryMainnet =
  "0x79c892AE9D910bBeb81705960BA01706Bb2Af02e";
export const ProviderAttributeRegistryMainnet =
  "0x4149Ff1496AA74F7A59989eb5332946fEed22705";
export const FizzRegistryMainnet = "0x1071F508b68E9cf8f338170295C952BDF509AE4D";
export const FizzAttributeRegistryMainnet =
  "0xB7AbA489Fe9F0eB930b8d298eD5FE669611cbf79";
export const EscrowUserMainnet = "0x67Ad502B202Ac602C215B2Ba28689a71d03F9Ba4";
export const EscrowProtocolMainnet =
  "0x7381F084D31EF2F983c95572b7DD6Ee99eE03d8d";
export const OrderRequestMainnet = "0xC1A0AF3224465c2a5099C14c5A1A4f6680C30A86";
export const ComputeLeaseMainnet = "0x8A9f22D855bBE978C0D47De0963a3B15022E8ce0";
export const BidMainnet = "0x1582D6f9A7098B112dC76dd55a98d11d95f4702A";
export const ResourceRegistryCPUMainnet =
  "0x8Ac7BD17fA6E51E9719FaEfD8FD8Cc46ECAa93A9";
export const ResourceRegistryGPUMainnet =
  "0x360135261AB6CF9c9bBeF4c5d2B1fB9bb1671C8e";
export const ResourceRegistryFactoryMainnet =
  "0xF302Af7f042A6D2e6A4c1fF67e4f69109d8f4Fa0";
export const ProviderRewardCalculatorMainnet =
  "0xa8F2FaECaeCe5654DB1927437b10852dffE659F6";
export const ProviderRewardManagerMainnet =
  "0x20f2159b1082529089752Bce0549a649B0f0032C";
export const FizzRewardCalculatorMainnet =
  "0x33Bdb47399e6b80a759658F35bcDD5Ce062dC25F";
export const FizzRewardManagerMainnet =
  "0x8A01206Fd078Be34b28d689C92C1f2C05B3C641B";
export const RewardTokenMainnet = "0xA0c5ba7d9eccbE59000e8E67654CA5d867C6b401";

export const legacyEscrow = "0x3854Be113E7B1C7fD8CF4805dF6c7f30d1FA1bC6";

// Mainnet Token Addresses
export const USPONMainnet = "0xBf0fA0461331d815A103e59929E5a19A48C30f5e";
export const SPONMainnet = "0x080d43c2164afdbc3712422ce78ab902ccab5ca1";

export const addressMap: Record<NetworkType, Record<string, string>> = {
  testnet: {
    accessControlManager: AccessControlManagerTestnet,
    tokenRegistry: TokenRegistryTestnet,
    providerRegistry: ProviderRegistryTestnet,
    providerAttributeRegistry: ProviderAttributeRegistryTestnet,
    fizzRegistry: FizzRegistryTestnet,
    fizzAttributeRegistry: FizzAttributeRegistryTestnet,
    escrow: EscrowUserTestnet,
    orderRequest: OrderRequestTestnet,
    computeLease: ComputeLeaseTestnet,
    bid: BidTestnet,
    resourceRegistryCPU: ResourceRegistryCPUTestnet,
    resourceRegistryGPU: ResourceRegistryGPUTestnet,
    resourceRegistryFactory: ResourceRegistryFactoryTestnet,
    providerRewardsManager: ProviderRewardsManagerTestnet,
    fizzRewardsManager: FizzRewardsManagerTestnet,
    fizzNodeRewardToken: FizzNodeRewardTokenTestnet,
    usdt: USDTTestnet,
    usdc: USDCTestnet,
    dai: DAITestnet,
    weth: WETHTestnet,
    cst: CSTTestnet,
    spon: SPONTestnet,
    uspon: USPONTestnet,
    legacyEscrow: legacyEscrow,
  },
  mainnet: {
    accessControlManager: AccessControlMainnet,
    tokenRegistry: TokenRegistryMainnet,
    providerRegistry: ProviderRegistryMainnet,
    providerAttributeRegistry: ProviderAttributeRegistryMainnet,
    fizzRegistry: FizzRegistryMainnet,
    fizzAttributeRegistry: FizzAttributeRegistryMainnet,
    escrow: EscrowUserMainnet,
    orderRequest: OrderRequestMainnet,
    computeLease: ComputeLeaseMainnet,
    bid: BidMainnet,
    resourceRegistryCPU: ResourceRegistryCPUMainnet,
    resourceRegistryGPU: ResourceRegistryGPUMainnet,
    resourceRegistryFactory: ResourceRegistryFactoryMainnet,
    providerRewardsManager: ProviderRewardManagerMainnet,
    fizzRewardsManager: FizzRewardManagerMainnet,
    uspon: USPONMainnet,
    spon: SPONMainnet,
    legacyEscrow: legacyEscrow,
  },
};
